import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';

import { PATH } from '@/shared/constants';
import { usePostArticleLikeApi } from '@/entities/article';

const useArticleLike = (id: string) => {
  const { mutate } = usePostArticleLikeApi();
  const queryClient = useQueryClient();
  const router = useRouter();

  const handleLikeAction = () => {
    mutate(Number(id), {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['articleActionStatusApi', Number(id)],
        });
      },
      onError: (error) => {
        if (error.message === 'Unauthorized') {
          router.push(`${PATH.AUTH_LOGIN}?next=${PATH.DETAIL}/${id}`);
        }
      },
    });
  };

  return { handleLikeAction };
};

export { useArticleLike };
